import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import React, { useState } from "react";
import { shadowSm, primary } from "../../colors";
import MyText from "./MyText";
import TextIcon from "../../assets/svg/TextIcon";
import TodayIcon from "../../assets/svg/TodayIcon";
import TrackIcon from "../../assets/svg/TrackIcon";
import StatusIcon from "../../assets/svg/StatusIcon";
import { width } from "../../imports";
import { currencyFormat } from "../../functions/functions";

export default function TransactionItem(props) {
  const { amount, date, description, refId, status, kind } = props;
  const [open, setOpen] = useState(false);
  return (
    <TouchableOpacity
      activeOpacity={1}
      onPress={() => setOpen(!open)}
      style={styles.container}
    >
      <View style={styles.price}>
        <MyText>{kind === "increase" ? "+" : "-"}</MyText>
        <MyText style={{ fontSize: 22, color: primary, marginHorizontal: 4 }}>
          {`${currencyFormat(amount)}`}
        </MyText>
        <MyText>تومان</MyText>
      </View>
      {!open && (
        <View style={styles.description}>
          <View style={[styles.row, { flex: 55, overflow: "hidden" }]}>
            <View>
              <TextIcon />
            </View>
            <MyText
              numberOfLines={1}
              style={{ overflow: "hidden", fontSize: 14 }}
            >
              {description}
            </MyText>
          </View>
          <View style={{ flex: 3 }}></View>
          <View style={[styles.row, { flex: 42, overflow: "hidden" }]}>
            <View>
              <TodayIcon />
            </View>
            <MyText numberOfLines={1}>{date.slice(0, 10)}</MyText>
          </View>
        </View>
      )}

      {!open && (
        <View style={styles.description}>
          <View style={[styles.row, { flex: 55, overflow: "hidden" }]}>
            <View style={{ marginHorizontal: 2 }}>
              <TrackIcon />
            </View>
            <MyText
              numberOfLines={1}
              style={{ overflow: "hidden", fontSize: 14 }}
            >
              {refId}
            </MyText>
          </View>
          <View style={{ flex: 3 }}></View>
          <View style={[styles.row, { flex: 42, overflow: "hidden" }]}>
            <View>
              <StatusIcon />
            </View>
            <MyText numberOfLines={1}>{status}</MyText>
          </View>
        </View>
      )}
      {open && (
        <View style={styles.description}>
          <View style={[styles.row, { flex: 55, overflow: "hidden" }]}>
            <View>
              <TextIcon />
            </View>
            <MyText
              numberOfLines={1}
              style={{ overflow: "hidden", fontSize: 14 }}
            >
              {description}
            </MyText>
          </View>
        </View>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    ...shadowSm,
    width: width - width / 20,
    padding: 10,
    marginVertical: 5,
    alignItems: "center",
  },
  price: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  description: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 8,
  },

  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
});
